import UiComponent from "./NavigatorBar.vue";
const _component = {
  install: function (Vue) {
    Vue.component("NavigatorBar", UiComponent);
  }
};
export default _component;
